import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivationEnd } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '../shared-service/services/user.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

    constructor(router: Router,
        private userService: UserService) {
            // router.events.subscribe(event => {
            //     // An event triggered at the end of the activation part of the Resolve phase of routing.
            //     if (event instanceof ActivationEnd) {
            //       // Cancel pending calls
            //       this.userService.cancelPendingRequests();
            //     }
            // });
    }

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
      return next.handle(req).pipe(takeUntil(this.userService.onCancelPendingRequests()));
    }
}
